<div class="content-box">
    <div class="content-box__base-information">
        <div class="content-box__base-information--title">
            {{'stats-and-resources.see-your-stats' | translate}}
        </div>
        <div class="content-box__base-information--description">
            {{'common.roboze-incloud' | translate}}
        </div>
        <div class="content-box__base-information--package">
            {{package}} <span class="endDate" *ngIf="endDate"><nb-icon icon="calendar-outline"></nb-icon>{{endDate | date : "dd.MM.yyyy"}}</span>
        </div>
        <!-- <div class="content-box__base-information--button">
            <button (click)="manageSubscriptions()">
                {{'stats-and-resources.manage-subscriptions' | translate}}
            </button>
        </div> -->
    </div>
</div>